import { useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { useParams } from 'react-router-dom';
import HorizontalCategory from './HorizontalCategory';
import PlainDish from './PlainDish';
import EditCategory from './Editor/EditCategory';
import EditPlainDish from './Editor/EditPlainDish';
import { 
    MdDelete, MdModeEditOutline, MdKeyboardBackspace, MdOutlineFastfood, MdOutlineFoodBank
} from 'react-icons/md';

const MenuEditor = (props) => {

    /* New/Edit Restaurant Variables */
    const { resID } = useParams();
    const [menu, setMenu] = useState();
    const [currentCategory, setCategory] = useState();

    const addCategory = (category) => {
        props.callback.showPopup('Agregar Categoria', <EditCategory eDB={props.eDB} resID={resID} menuList={menu} setMenuList={setMenu} menu={category} setCurrent={setCategory} close={props.callback.closePopup} new/>);
    }

    const editCategory = (category) => {
        const menuPos = menu.indexOf(currentCategory);
        props.callback.showPopup('Modificar Categoria', <EditCategory eDB={props.eDB} resID={resID} menuID={category.id} menuList={menu} setMenuList={setMenu} menuPos={menuPos} menu={category} setCurrent={setCategory} close={props.callback.closePopup} edit/>);
    }

    const deleteCategory = (category) => {
        props.callback.showPopup('Eliminar Categoria', <EditCategory eDB={props.eDB} resID={resID} menuID={category.id}  menuList={menu} setMenuList={setMenu} menu={category} setCurrent={setCategory} close={props.callback.closePopup} delete/>);
    }

    const addDish = () => {
        const menuPos = menu.indexOf(currentCategory);
        props.callback.showPopup('Agregar Platillo', <EditPlainDish resID={resID} menuID={currentCategory.id} eDB={props.eDB} menuPos={menuPos} menuList={menu} setMenuList={setMenu} setCurrent={setCategory} close={props.callback.closePopup} new/>);
    }

    const editDish = (dish) => {
        const menuPos = menu.indexOf(currentCategory);
        props.callback.showPopup('Modificar Platillo', <EditPlainDish resID={resID} menuID={currentCategory.id} eDB={props.eDB} menuPos={menuPos} menuList={menu} setMenuList={setMenu} menu={dish} setCurrent={setCategory} close={props.callback.closePopup} edit/>);
    }

    const deleteDish = (dish) => {
        const menuPos = menu.indexOf(currentCategory);
        props.callback.showPopup('Modificar Platillo', <EditPlainDish resID={resID} menuID={currentCategory.id} eDB={props.eDB} menuPos={menuPos} menuList={menu} setMenuList={setMenu} menu={dish} setCurrent={setCategory} close={props.callback.closePopup} delete/>);
    }

    const callback = {
        edit: editDish,
        delete: deleteDish
    }

    useEffect(() => {
        if(!menu){
            getDocs(collection(props.eDB, 'Restaurants',resID,'Menu'))
            .then((querySnapshot) => {
                let newMenuList =  [];
                querySnapshot.forEach((doc) => {
                    newMenuList.push({...doc.data(), id: doc.id});
                });
                setMenu(newMenuList);
            });
        }else{
            setCategory(menu[0]);
        }
    }, [menu, props.eDB, resID]);

    return(
        <>
            <div className='fitHeight'>
                <div className='title d-flex tx-white'><button onClick={() => props.router(-1)} style={{border: '0', background: 'none', cursor: 'pointer'}}><MdKeyboardBackspace size='1.5rem' color='white'/></button>Editar Menu</div>
                <div style={{backgroundColor: 'white'}} className='ContentContainer tx-primary mt-2 bg-rounded bg-container no-scroll'>
                    <div className='d-flex title pb-1'>
                        <strong>Categorias</strong>
                        &nbsp;&nbsp;
                        <div className='d-inline-block d-flex flex-center'>
                            <button onClick={addCategory} className='cbtn-md-add d-inline-block mx-1'>
                                <MdOutlineFoodBank size='1rem' pointerEvents='none' />
                            </button><span className='btn-label'>Agregar</span>
                        </div>
                    </div>
                    <div className='d-grid'>
                        <div className='horizontalOverflow'>
                            <HorizontalCategory callback={setCategory} current={currentCategory} list={menu ? menu:[] } />
                        </div>
                    </div>

                    <div className='tx-alt pt-3 pb-2'>
                        <pre className='no-scroll' style={{maxHeight: '150px', overflowY: 'auto', whiteSpace: 'pre-line'}}>{currentCategory ? currentCategory.description : 'Este restaurante aun no tiene ninguna categoria agregada.'}</pre>
                    </div>

                    <div className='title py-1 tx-red'>
                        {
                            currentCategory ? 
                            currentCategory.name:'Sin Categorias'
                        }
                        &nbsp;&nbsp;
                        {
                            currentCategory && <>
                                <button onClick={() => editCategory(currentCategory)} className='cbtn-md d-inline-block mx-1'>
                                    <MdModeEditOutline pointerEvents='none' />
                                </button>
                                <button onClick={() => deleteCategory(currentCategory)} className='cbtn-md d-inline-block'>
                                    <MdDelete pointerEvents='none' />
                                </button>

                                &nbsp;&nbsp;
                                <div className='d-inline-block d-flex flex-center'>
                                    <button onClick={addDish} className='cbtn-md-add d-inline-block mx-1'>
                                        <MdOutlineFastfood size='1rem' pointerEvents='none' />
                                    </button><span className='btn-label tx-secondary'>Agregar platillo</span>
                                </div>
                            </>
                        }
                    </div>
                    <div className='py-2'>
                        {
                            currentCategory && currentCategory.dishes.map((dish, index) => {
                                return <PlainDish key={index} data={dish} callback={callback} />;
                            })
                        }
                    </div>
                </div>
            </div>
        </>
    );
}

export default MenuEditor;